var map = {
	"./account-number.svg": 1655,
	"./account-star.svg": 1656,
	"./account.svg": 1657,
	"./alert-danger.svg": 1658,
	"./alert-primary.svg": 1659,
	"./alert-success.svg": 1660,
	"./alert-warning.svg": 1661,
	"./angle-down-filled.svg": 1662,
	"./angle-left-filled.svg": 1663,
	"./angle-play-filled.svg": 1664,
	"./angle-right-filled.svg": 1665,
	"./angle-up-filled.svg": 1666,
	"./angle_down.svg": 1667,
	"./angle_right_circle.svg": 1668,
	"./angle_up.svg": 1669,
	"./announce-lined.svg": 1670,
	"./announce.svg": 1671,
	"./area-filled.svg": 1672,
	"./arrow-down-lined.svg": 1673,
	"./arrow-left-begin-lined.svg": 1674,
	"./arrow-left-lined.svg": 1675,
	"./arrow-right-end-lined.svg": 1676,
	"./arrow-right-lined.svg": 1677,
	"./arrow-up-lined.svg": 1678,
	"./arrow_down.svg": 1679,
	"./arrow_left.svg": 1680,
	"./arrow_right.svg": 1681,
	"./arrow_up.svg": 1682,
	"./arrowdown2.svg": 1683,
	"./arrowup2.svg": 1684,
	"./back.svg": 1685,
	"./bell-filled.svg": 1686,
	"./bell-lined.svg": 1687,
	"./check-circle-fill.svg": 1688,
	"./check-circle.svg": 1689,
	"./check-lined.svg": 1690,
	"./check.svg": 1691,
	"./circle-angle-right-lined.svg": 1692,
	"./circle-angle-two-lined.svg": 1693,
	"./circle-check-filled.svg": 1694,
	"./circle-check-lined.svg": 1695,
	"./circle-close-filled.svg": 1696,
	"./circle-close-lined.svg": 1697,
	"./circle-help-filled.svg": 1698,
	"./circle-line.svg": 1699,
	"./circle-lined.svg": 1700,
	"./circle-minus-filled.svg": 1701,
	"./circle-minus-lined.svg": 1702,
	"./circle-pause-lined.svg": 1703,
	"./circle-photo-lined.svg": 1704,
	"./circle-plus-filled.svg": 1705,
	"./circle-process-filled.svg": 1706,
	"./circle-question-lined.svg": 1707,
	"./circle-reload-lined.svg": 1708,
	"./circle-smile-lined.svg": 1709,
	"./circle-stop-lined.svg": 1710,
	"./circle-time-lined.svg": 1711,
	"./circle-warning-filled.svg": 1712,
	"./circle-warning-lined.svg": 1713,
	"./close-x-lined.svg": 1714,
	"./close-x.svg": 1715,
	"./close.svg": 1716,
	"./close_fill.svg": 1717,
	"./close_line.svg": 1718,
	"./contact.svg": 1719,
	"./current.svg": 1720,
	"./customers-lined.svg": 1721,
	"./date.svg": 1722,
	"./defaultIcon.svg": 1723,
	"./default_image.svg": 1724,
	"./delete.svg": 1725,
	"./device.svg": 1726,
	"./disable.svg": 1727,
	"./divider.svg": 1728,
	"./document-color.svg": 1729,
	"./dot-three-lined.svg": 1730,
	"./download-lined.svg": 1731,
	"./drag.svg": 1732,
	"./dropdown.svg": 1733,
	"./earth-lined.svg": 1734,
	"./edit.svg": 1735,
	"./enter-wechat-color.svg": 1736,
	"./eye-lined.svg": 1737,
	"./file-excel-filled.svg": 1738,
	"./file-image-filled.svg": 1739,
	"./file-music-filled.svg": 1740,
	"./file-pdf-filled.svg": 1741,
	"./file-ppt-fill.svg": 1742,
	"./file-ppt-filled.svg": 1743,
	"./file-txt-filled.svg": 1744,
	"./file-unknown-fill.svg": 1745,
	"./file-unknown-filled.svg": 1746,
	"./file-video-fill.svg": 1747,
	"./file-video-filled.svg": 1748,
	"./file-word-fill.svg": 1749,
	"./file-word-filled.svg": 1750,
	"./file-zip-filled.svg": 1751,
	"./filter-lined.svg": 1752,
	"./gear-filled.svg": 1753,
	"./home-base-lined.svg": 1754,
	"./irregular-check-lined.svg": 1755,
	"./loading-filled.svg": 1756,
	"./loading.svg": 1757,
	"./lock-filled.svg": 1758,
	"./lock-lined.svg": 1759,
	"./lookup.svg": 1760,
	"./menu_spread.svg": 1761,
	"./message-error.svg": 1762,
	"./message-info.svg": 1763,
	"./message-lined.svg": 1764,
	"./message-success.svg": 1765,
	"./message-warning.svg": 1766,
	"./minus.svg": 1767,
	"./mobile-lined.svg": 1768,
	"./more.svg": 1769,
	"./nodata_image.svg": 1770,
	"./notification.svg": 1771,
	"./order-quotation-lined.svg": 1772,
	"./orders_fill.svg": 1773,
	"./pause-lined.svg": 1774,
	"./phone-lined.svg": 1775,
	"./plus-lined.svg": 1776,
	"./plus.svg": 1777,
	"./plus_bold.svg": 1778,
	"./record-lined.svg": 1779,
	"./redo.svg": 1780,
	"./region-lined.svg": 1781,
	"./required-lined.svg": 1782,
	"./rollback-lined.svg": 1783,
	"./safety-check-lined.svg": 1784,
	"./save-lined.svg": 1785,
	"./save.svg": 1786,
	"./search-lined.svg": 1787,
	"./shopping-cart-lined.svg": 1788,
	"./slash-lined.svg": 1789,
	"./sound-Mute.svg": 1790,
	"./sound-loud-fill.svg": 1791,
	"./sound-low-fill.svg": 1792,
	"./square-Import-lined.svg": 1793,
	"./square-export-lined.svg": 1794,
	"./stamp-filled.svg": 1795,
	"./stamp-lined.svg": 1796,
	"./top-lined.svg": 1797,
	"./trash-can-lined.svg": 1798,
	"./two-left-points-lined.svg": 1799,
	"./undo.svg": 1800,
	"./upload-color.svg": 1801,
	"./upload-lined.svg": 1802,
	"./upload.svg": 1803,
	"./user-lined.svg": 1804,
	"./user_lined.svg": 1805,
	"./wechat-color.svg": 1806,
	"./wrong-circle.svg": 1807
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2245;


//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/assets/icons/svgs nonrecursive ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}! .svg$
// module id = 2245
// module chunks = 137